import ProviderService from "../../../../../../services/ProviderService";
import {
  isSet,
  optionsToKeyValuePairs,
} from "../../../../../../utils/commonUtils";
import { OnTabKeyPress } from "../../../../../../utils/cssUtils";

export const MobileHealthVROS = (props, type = "Others") => {
  const stackedFieldStyle = {
    layout: 'stacked',
    showContainerBorder: false,
    labelWrap: false,
    isLabel: true,
  };
  console.log("MobileHealthVROS props", props.hasEditAccess);
  const physicalExamination = [
    { label: "General", name: "general", notesName: "general_notes" },
    {
      label: "Respiratory",
      name: "respiratory",
      notesName: "respiratory_notes",
    },
    {
      label: "Cardiovascular",
      name: "cardiovascular",
      notesName: "cardiovascular_notes",
    },
    {
      label: "Gastrointestinal",
      name: "gastrointestinal",
      notesName: "gastrointestinal_notes",
    },
    { label: "Urinary", name: "urinary", notesName: "urinary_notes" },
    {
      label: "Musculoskeletal",
      name: "musculoskeletal",
      notesName: "musculoskeletal_notes",
    },
    {
      label: "Neurological",
      name: "neurological",
      notesName: "neurological_notes",
    },
    { label: "Skin", name: "skin", notesName: "skin_notes" },
    { label: "Endocrine", name: "endocrine", notesName: "endocrine_notes" },
    { label: "Hematology", name: "hematology", notesName: "hematology_notes" },
    {
      label: "Allergy / Immunology",
      name: "allergy_immunology",
      notesName: "allergy_immunology_notes",
    },
    {
      label: "Psychiatric",
      name: "psychiatric",
      notesName: "psychiatric_notes",
    },
  ];
  let patientQuestions = [
    {
      label:
        "1. Do you have any of the following symptoms: coughing for three or more weeks, coughing up blood, persistent SOB, pain or pain with breathing or coughing, unintentional weight loss, loss of appetite, fatigue, fever, night sweats or chills which could be indicative of a TB infection?",
      name: "symptoms",
    },
    {
      label:
        "2. Have you ever been exposed to anyone exhibiting the above signs or symptoms, or someone who has had active TB?",
      name: "exposed_to_tb",
    },
    {
      label:
        "3. Do you have a history of temporary or permanent residence (for > 1 month) in a country with a high TB rate? (i.e., any country other than Australia, Canada, New Zealand, the United States, and those in western or northern Europe)",
      name: "travel_history",
    },
    {
      label:
        "4. Are you or do you plan immunosuppression, including receipt of an organ transplant, treatment with an TFN-alpha antagonist (e.g., infliximab, etanercept, or other), chronic steroids (equivalent of prednisone > 15 mg/day for > 1 month) or other immunosuppressive medication, or do you have human immunodeficiency virus infection?",
      name: "immunosuppression",
    },
  ];

  const clinicianQuestions = [
    {
      label: "1. Does the individual report TB-like symptoms?",
      name: "clinician_tb_like_symptoms",
    },
    {
      label: "2.Does the individual identify TB risk factors?",
      name: "clinician_tb_risk_factors",
    },
    {
      label:
        "3. Does the individual have medical conditions related to immunosuppression?",
      name: "clinician_medical_conditions",
    },
  ];

  const charts = [
    props.hasEditAccess
    ? {
        type: "Grid",
        col: "col-md-3",
        data: [
          { type: "PatientDetails", employeeDetails: props.employeeDetails, visitDetails: props.visitDetails },
          { type: "CompanyDetails", companyDetails: props.companyDetails },
        ],
      }
    : null,
    {
      type: "Tab",
      col: `col-md-${props.hasEditAccess ? "9" : "12"}`,
      data: [
        {
          id: "patient",
          data: [
            {
              label: "Gynecological Information",
              // note:(type==='ProviderExam')?'Examination Report (to be filled out by the medical examiner)':'Examination Report (to be filled out by the Provider)',
              fields: [
                {
                  label: "Last Menstrual Period",
                  type: "Date",
                  labelWrap: false,
                  name: "last_menstrual_period",
                  col: "col-12",
                  id: "last_menstrual_period",
                },
                {
                  label: "None",
                  type: "Checkbox",
                  name: "menstrual_comments_none",
                  id: "menstrual_comments_none",
                  labelWrap: false,
                  col: "col-md-6 col-12",
                },
                {
                  label: "Last Menstrual Period Comments (select which apply):",
                  col: "col-12",
                  type: "CheckBoxGroup",
                  name: "menstrual_comments",
                  //   isMulti: true,
                  id: "menstrual_comments",
                  options: [
                    {
                      label: "Irregular menstrual cycle",
                      name: "irregular_menstrual_cycle",
                    },
                    { label: "Pregnancy", name: "pregnancy" },
                    { label: "Menopause", name: "menopause" },
                    { label: "Perimenopause", name: "perimenopause" },
                    { label: "Oophorectomy", name: "oophorectomy" },
                    { label: "Hysterectomy", name: "hysterectomy" },
                    { label: "Depo-Provera", name: "depo_provera" },
                    { label: "Breastfeeding", name: "breastfeeding" },
                    { label: "Implanon", name: "implanon" },
                    { label: "Unknown", name: "unknown" },
                  ],
                  combineToKey: "menstrual_comments",
                  rules: [
                    {
                      rule: [
                        {
                          field: "menstrual_comments_none",
                          value: 1,
                          operator: "===",
                        },
                      ],
                      action: "CLEAR",
                    },
                  ]
                },
                {
                  label: "If pregnant, what is the EDC?",
                  type: "TextInput",
                  name: "edc_notes",
                  col: "col-12",
                  id: "edcInput",
                  className: "form-control col-md-6 col-12 form-control-solid",
                  placeholder: "EDC",
                  rules: [
                    {
                      rule: [
                        {
                          field: "menstrual_comments",
                          value: "pregnancy",
                          operator: "includes",
                        },
                      ],
                      action: "SHOW",
                    },
                  ],
                },
              ],
            },
            {
              label: "Past Medical Illness:",
              fields: [
                {
                  label: "None",
                  type: "Checkbox",
                  name: "past_medical_illness_none",
                  id: "past_medical_illness_none",
                  labelWrap: false,
                  col: "col-md-6 col-12",
                },
                {
                  label: "Past Medical Illness:",
                  col: "col-12",
                  type: "CheckBoxGroup",
                  name: "past_medical_illness",
                  isMulti: true,
                  id: "past_medical_illness",
                  combineToKey: "past_medical_illness",
                  options: [
                    { label: "Measles", name: "measles" },
                    { label: "Rubella", name: "rubella" },
                    {
                      label: "Varicella (Chicken Pox)",
                      name: "varicella_chicken_pox",
                    },
                    { label: "Mumps", name: "mumps" },
                    { label: "Tuberculosis", name: "tuberculosis" },
                  ],
                  rules: [
                    {
                      rule: [
                        {
                          field: "past_medical_illness_none",
                          value: 1,
                          operator: "===",
                        },
                      ],
                      action: "CLEAR",
                    },
                  ]
                },
              ],
            },
            {
              label: " Past Medical History:",
              // note:(type==='ProviderExam')?'Examination Report (to be filled out by the medical examiner)':'Examination Report (to be filled out by the Provider)',
              fields: [
                {
                  label: "None",
                  type: "Checkbox",
                  name: "past_medical_history_none",
                  id: "past_medical_history_none",
                  labelWrap: false,
                  col: "col-md-6 col-12",
                },
                {
                  label: "Past Medical History:",
                  col: "col-12",
                  type: "CheckBoxGroup",
                  name: "past_medical_history",
                  isMulti: true,
                  id: "past_medical_history",
                  combineToKey: "past_medical_history",
                  options: [
                    { label: "Anemia", name: "anemia" },
                    { label: "Anxiety", name: "anxiety" },
                    { label: "Asthma", name: "asthma" },
                    { label: "Cancer", name: "cancer" },
                    { label: "Cataracts", name: "cataracts" },
                    {
                      label: "COPD or Lung Disease",
                      name: "copd_or_lung_disease",
                    },
                    { label: "Diabetes Type I", name: "diabetes_type_i" },
                    { label: "Diabetes Type II", name: "diabetes_type_ii" },
                    { label: "Epilepsy", name: "epilepsy" },
                    { label: "GERD/GI Disorder", name: "gerd_gi_disorder" },
                    { label: "Glaucoma", name: "glaucoma" },
                    { label: "Headaches", name: "headaches" },
                    { label: "Heart Disease", name: "heart_disease" },
                    { label: "Hepatitis", name: "hepatitis" },
                    {
                      label: "High Blood Pressure",
                      name: "high_blood_pressure",
                    },
                    {
                      label: "Hypercholesterolemia (Lipid Disorder)",
                      name: "hypercholesterolemia_lipid_disorder",
                    },
                    { label: "Hyperthyroid", name: "hyperthyroid" },
                    { label: "Hypothyroid", name: "hypothyroid" },
                    { label: "Injury: non-work", name: "injury_non_work" },
                    { label: "Injury: work", name: "injury_work" },
                    { label: "Kidney Disease", name: "kidney_disease" },
                    { label: "Liver Disease", name: "liver_disease" },
                    {
                      label: "Motor Vehicle Accident",
                      name: "motor_vehicle_accident",
                    },
                    {
                      label: "Musculoskeletal disorder",
                      name: "musculoskeletal_disorder",
                    },
                    {
                      label: "Neck or lower back pain",
                      name: "neck_or_lower_back_pain",
                    },
                    { label: "Neuropathy", name: "neuropathy" },
                    {
                      label: "Sickle Cell Trait or Disease",
                      name: "sickle_cell_trait_or_disease",
                    },
                    { label: "Stroke/CVA/TIA", name: "stroke_cva_tia" },
                    { label: "Others", name: "-" },
                  ],
                  rules: [
                    {
                      rule: [
                        {
                          field: "past_medical_history_none",
                          value: 1,
                          operator: "===",
                        },
                      ],
                      action: "CLEAR",
                    },
                  ]
                },
                {
                  label: "Hepatitis Type",
                  type: "TextInput",
                  name: "hepatitis_type",
                  col: "col-12",
                  id: "hepatitis_type",
                  className: "form-control col-md-6 col-12 form-control-solid",
                  placeholder: "Hepatitis Type",
                  rules: [
                    {
                      rule: [
                        {
                          field: "past_medical_history",
                          value: "hepatitis",
                          operator: "includes",
                        },
                      ],
                      action: "SHOW",
                    },
                  ],
                },
                {
                  label: "Others specify",
                  type: "TextInput",
                  name: "past_medical_history_others",
                  col: "col-12",
                  id: "past_medical_history_others",
                  className: "form-control col-md-6 col-12 form-control-solid",
                  placeholder: "Others",
                  rules: [
                    {
                      rule: [
                        {
                          field: "past_medical_history",
                          value: "-",
                          operator: "includes",
                        },
                      ],
                      action: "SHOW",
                    },
                  ],
                },
              ],
            },
            {
              label: "Past Surgical History:",
              // note:(type==='ProviderExam')?'Examination Report (to be filled out by the medical examiner)':'Examination Report (to be filled out by the Provider)',
              fields: [
                {
                  label: "None",
                  type: "Checkbox",
                  name: "past_surgical_history_none",
                  id: "past_surgical_history_none",
                  labelWrap: false,
                  col: "col-md-6 col-12",
                },
                {
                  label: "Past Surgical History:",
                  col: "col-12",
                  type: "CheckBoxGroup",
                  name: "past_surgical_history",
                  isMulti: true,
                  id: "past_surgical_history",
                  combineToKey: "past_surgical_history",
                  options: [
                    { label: "Appendectomy", name: "appendectomy" },
                    { label: "Breast reduction", name: "breast_reduction" },
                    { label: "C-Section", name: "c_section" },
                    { label: "Cataract removal", name: "cataract_removal" },
                    { label: "Cholecystectomy", name: "cholecystectomy" },
                    { label: "Hemmorhoidectomy", name: "hemmorhoidectomy" },
                    { label: "Hysterectomy", name: "hysterectomy" },
                    { label: "Laminectomy", name: "laminectomy" },
                    { label: "Liposuction", name: "liposuction" },
                    { label: "Lumpectomy", name: "lumpectomy" },
                    { label: "Mastectomy", name: "mastectomy" },
                    {
                      label: "Ovarian cystectomy",
                      name: "ovarian_cystectomy",
                    },
                    { label: "Salpingectomy", name: "salpingectomy" },
                    { label: "Thyroidectomy", name: "thyroidectomy" },
                    { label: "Tonsillectomy", name: "tonsillectomy" },
                    { label: "Tubal Ligation", name: "tubal_ligation" },
                  ],
                  rules: [
                    {
                      rule: [
                        {
                          field: "past_surgical_history_none",
                          value: 1,
                          operator: "===",
                        },
                      ],
                      action: "CLEAR",
                    },
                  ]
                },
                {
                  label: "Date of last surgery",
                  type: "Date",
                  name: "date_of_last_surgery",
                  col: "col-12",
                  id: "date_of_last_surgery",
                  className: "form-control col-md-6 col-12 form-control-solid",
                  placeholder: "Date of last surgery",
                },
                {
                  label: "Others surgical notes",
                  type: "TextInput",
                  name: "other_surgical_notes",
                  col: "col-12",
                  id: "other_surgical_notes",
                  className: "form-control col-md-6 col-12 form-control-solid",
                  placeholder: "Others surgical notes",
                },
              ],
            },
            {
              label: "Medications:",
              fields: [
                {
                  label: "None",
                  type: "Checkbox",
                  col: "col-md-6 col-12",
                  name: "taking_medications",
                  id: "taking_medications",
                  // placeholder:'Medication Name 1'
                },
                {
                  label: "If Use Reported, list all medications:",
                  col: "col-12",
                  type: "Label",
                },
                {
                  label: "Medication Name 1",
                  type: "TextInput",
                   col: "col-md-6 col-12",
                  name: "medication_name_1",
                  id: "medication_name_1",
                  placeholder: "Medication Name 1",
                  // disabled: true,
                  rules: [
                    {
                      rule: [
                        {
                          field: "taking_medications",
                          value: 1,
                          operator: "===",
                        },
                      ],
                      action: "CLEAR",
                    },
                  ],
                },
                {
                  label: "Medication Name 2",
                  type: "TextInput",
                   col: "col-md-6 col-12",
                  name: "medication_name_2",
                  id: "medication_name_2",
                  placeholder: "Medication Name 2",
                  // disabled: true,
                  rules: [
                    {
                      rule: [
                        {
                          field: "taking_medications",
                          value: 1,
                          operator: "===",
                        },
                      ],
                      action: "CLEAR",
                    },
                  ],
                },
                {
                  label: " Medication Name 3",
                  type: "TextInput",
                   col: "col-md-6 col-12",
                  name: "medication_name_3",
                  id: "medication_name_3",
                  placeholder: "Medication Name 3",
                  // disabled: true,
                  rules: [
                    {
                      rule: [
                        {
                          field: "taking_medications",
                          value: 1,
                          operator: "===",
                        },
                      ],
                      action: "CLEAR",
                    },
                  ],
                },
                {
                  label: "Medication Name 4",
                  type: "TextInput",
                   col: "col-md-6 col-12",
                  name: "medication_name_4",
                  id: "medication_name_4",
                  placeholder: "Medication Name 4",
                  // disabled: true,
                  rules: [
                    {
                      rule: [
                        {
                          field: "taking_medications",
                          value: 1,
                          operator: "===",
                        },
                      ],
                      action: "CLEAR",
                    },
                  ],
                },
                {
                  label: "Medication Name 5",
                  type: "TextInput",
                   col: "col-md-6 col-12",
                  name: "medication_name_5",
                  id: "medication_name_5",
                  placeholder: "Medication Name 5",
                  // disabled: true,
                  rules: [
                    {
                      rule: [
                        {
                          field: "taking_medications",
                          value: 1,
                          operator: "===",
                        },
                      ],
                      action: "CLEAR",
                    },
                  ],
                },
                {
                  label: "Medication Name 6",
                  type: "TextInput",
                   col: "col-md-6 col-12",
                  name: "medication_name_6",
                  id: "medication_name_6",
                  placeholder: "Medication Name 6",
                  // disabled: true,
                  rules: [
                    {
                      rule: [
                        {
                          field: "taking_medications",
                          value: 1,
                          operator: "===",
                        },
                      ],
                      action: "CLEAR",
                    },
                  ],
                },
                                {
                  label: "None",
                  type: "Checkbox",
                  col: "col-md-6 col-12",
                  name: "allergies_none",
                  id: "allergies_none",
                  // placeholder:'Medication Name 1'
                },
                {
                  label: "Allergies:",
                  col: "col-12",
                  type: "CheckBoxGroup",
                  name: "allergies",
                  isMulti: true,
                  id: "allergies",
                  combineToKey: "allergies",
                  options: [
                    { label: "Seasonal", name: "seasonal" },
                    { label: "Penicillin", name: "penicillin" },
                    { label: "Environmental", name: "environmental" },
                    { label: "Perfume", name: "perfume" },
                    { label: "Smoke", name: "smoke" },
                    { label: "Vinyl", name: "vinyl" },
                    { label: "Nitrate", name: "nitrate" },
                    { label: "Latex", name: "latex" },
                    { label: "Animal/Pet Dander", name: "animal_pet_dander" },
                    { label: "Other/Drug", name: "-" },
                  ],
                  rules: [
                    {
                      rule: [
                        {
                          field: "allergies_none",
                          value: 1,
                          operator: "===",
                        },
                      ],
                      action: "CLEAR",
                    },
                  ]
                },
                {
                  label: "Others specify",
                  type: "TextArea",
                  name: "allergies_others",
                  col: "col-12",
                  id: "allergies_others",
                  className: "form-control col-md-6 col-12 form-control-solid",
                  placeholder: "Other/Drug",
                  rules: [
                    {
                      rule: [
                        {
                          field: "allergies",
                          value: "-",
                          operator: "includes",
                        },
                      ],
                      action: "SHOW",
                    },
                  ],
                },
                {
                  label: "Please list known allergic reactions:",
                  type: "TextArea",
                  name: "allergy_reaction_notes",
                  col: "col-12",
                  id: "allergy_reaction_notes",
                  className: "form-control col-md-6 col-12 form-control-solid",
                  placeholder: "Allergic Reactions",
                  rules: [
                    {
                      rule: [
                        {
                          field: "allergies_none",
                          value: 1,
                          operator: "===",
                        },
                      ],
                      action: "CLEAR",
                    },
                  ],
                },
                {
                  label: "Social History:",
                  col: "col-12",
                  type: "Label",
                },
                {
                  label: "Tobacco Use:",
                  col: "col-12",
                  type: "RadioGroup",
                  name: "tobacco_use",
                  id: "tobacco_use",
                  options: [
                    "Does not smoke",
                    "Smoke several cigarettes per day",
                    "Smokes >1 pack/day",
                    "Social Smoker",
                  ],
                },
                                                {
                  label: "Does not Smoke",
                  type: "Checkbox",
                  col: "col-md-6 col-12",
                  name: "length_of_tobacco_use_none",
                  id: "length_of_tobacco_use_none",
                  // placeholder:'Medication Name 1'
                },
                {
                  label: "Length of Tobacco Use:",
                  col: "col-12",
                  type: "RadioGroup",
                  name: "length_of_tobacco_use",
                  id: "length_of_tobacco_use",
                  options: [ "1-5 years", "6-10 years", ">10 years"],
                  rules: [
                    {
                      rule: [
                        {
                          field: "length_of_tobacco_use_none",
                          value: 1,
                          operator: "===",
                        },
                      ],
                      action: "CLEAR",
                    },
                  ]
                },
                {
                  label: "Alcohol Use:",
                  col: "col-12",
                  type: "RadioGroup",
                  name: "alcohol_use",
                  id: "alcohol_use",
                  options: [
                    "Does not consume alcohol",
                    "Consumes alcohol socially",
                    "Consumes alcohol occasionally",
                    "Consumes alcohol on a daily basis",
                  ],
                },
              ],
            },
            {
              label: " Patient Confirmation:",
              fields: [
                {
                  label:
                    "I attest that I am free from habit or addiction to alcohol, depressants, stimulants, narcotics or other drugs or substances which may alter my behavior:",
                  col: "col-12",
                  type: "RadioGroup",
                  labelWrap: false,
                  name: "patient_confirmation",
                  id: "patient_confirmation",
                  options: [
                    { label: "Yes", value: 1 },
                    { label: "No", value: 0 },
                  ],
                },
                {
                  label: "Signature",
                  type: "Signature",
                  col: "col-md-6 col-12",
                  name: "patient_signature_data",
                  id: "patient_signature_data",
                  disabled: true,
                  rules: [
                    {
                      rule: [
                        {
                          field: "patient_confirmation",
                          value: "",
                          operator: "!==",
                        },
                      ],
                      action: "ENABLE",
                    },
                  ],
                },
                {
                  label: "Date",
                  type: "Date",
                  col: "col-md-6 col-12",
                  name: "patient_signature_date",
                  id: "patient_signature_date",
                  disabled: true,
                  rules: [
                    {
                      rule: [
                        {
                          field: "patient_confirmation",
                          value: "",
                          operator: "!==",
                        },
                      ],
                      action: "ENABLE",
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          id: "provider",
          data: [
            {
              label: "Vital Signs & Measurements",
              fields: [
                {
                  label: "Height(Inches)",
                  ...stackedFieldStyle,
                  placeholder: "Inches",
                  col: "col-md-6 col-12",
                  type: "Number",
                  name: "height",
                  id: "height",
                  max:2,
                },
                {
                  label: "Weight(Lbs)",
                  ...stackedFieldStyle,
                  placeholder: "Lbs",
                  col: "col-md-6 col-12",
                  type: "Number",
                  name: "weight",
                  id: "weight",
                  max:3,
                },
                {
                  label:'Blood Pressure Systolic (1st Reading)',
                  ...stackedFieldStyle,
                  col: 'col-6 border-0 ',
                  type:'Number',
                  placeholder:"Blood pressure",
                  name:'sitting_systolic',
                  id:'sitting_systolic',
                  rangeMax:139,
                  rangeMin:90,
                  onKeyPress:(event)=>OnTabKeyPress(event,"sitting_diastolic",""),
                  max:3,
              },
              {
                  label:'Blood Pressure Systolic(2nd Reading)',
                  ...stackedFieldStyle,
                  col: 'col-6 border-0 ',
                  type:'Number',
                  placeholder:"Blood pressure",
                  name:'second_reading_systolic',
                  id:'second_reading_systolic',
                  rangeMax:139,
                  rangeMin:90,
                  max:3,
              },  
              {
                  label:'Blood Pressure Diastolic (1st Reading)',
                  ...stackedFieldStyle,
                  col: 'col-6 border-0 ',
                  type:'Number',
                  placeholder:"Blood pressure",
                  name:'sitting_diastolic',
                  id:'sitting_diastolic',
                   rangeMin:60,
                  rangeMax:89,
                  OnTabKeyPress:(event)=>OnTabKeyPress(event,"pulse_rate"),
                  max:3,
              },
              {
                  label:'Blood Pressure Diastolic(2nd Reading)',
                  ...stackedFieldStyle,
                  col: 'col-6 border-0 ',
                  type:'Number',
                  placeholder:"Blood pressure",
                  name:'second_reading_diastolic',
                  id:'second_reading_diastolic',
                  rangeMin:60,
                  rangeMax:89,
                  max:3,
              },  
                {
                  label: "Pulse",
                  ...stackedFieldStyle,
                  type: "Number",
                  col: "col-md-6 col-12",
                  name: "pulse",
                  rangeMin: 60,
                  rangeMax: 100,
                  id: "pulse",
                  placeholder: "pulse",
                  max:3,
                },
                {
                  label: "Respiration",
                  ...stackedFieldStyle,
                  type: "Number",
                  col: "col-md-6 col-12",
                  name: "respiration",
                  id: "respiration",
                  placeholder: "respiration",
                  max:3,
                },
                {
                  label: "  Temperature(°F)",
                  ...stackedFieldStyle,
                  type: "Decimal",
                  col: "col-md-6 col-12",
                  name: "temperature_f",
                  id: "temperature_f",
                  // rangeMin: 97,
                  // rangeMax: 99,
                  placeholder: "Temperature(°F)",
                },
                {
                  col: "col-12",
                  label: "",
                  defaultBtnLabel: "Set all to Normal",
                  type: "YesOrNoTable",
                  options: [
                    { label: "Within Normal Limits ", value: "Normal" },
                    { label: "Abnormal", value: "Abnormal" },
                  ],
                  defaultValues: physicalExamination.reduce((acc, itm) => {
                    acc[itm.name] = "Normal";
                    return acc;
                  }, {}),
                  list: physicalExamination,
                  showNotes: true,
                  failedValue: ["Abnormal"],
                },
                {
                  label: "Comments:",
                  type: "TextArea",
                  name: "clinician_comments",
                  id: "clinician_comments",
                  placeholder: "Comments",
                  col: "col-12",
                },
                {
                    label: "Printed Name",
                    type: "TextInput",
                    col: "col-md-6 col-12",
                    name: "clinician_printed_name",
                    id: "clinician_printed_name",
                    placeholder: "Printed Name",
                  },
                  {
                    label: "License Number & State",
                    type: "TextInput",
                    col: "col-md-6 col-12",
                    name: "clinician_license_number_state",
                    id: "clinician_license_number_state",
                    placeholder: "License Number & State ",
                  },
                  {
                    label: "Date",
                    type: "Date",
                    col: "col-md-6 col-12",
                    name: "clinician_signature_date",
                    id: "clinician_signature_date",
                  },
                  {
                    label: "Clinician Signature",
                    type: "Signature",
                    col: "col-md-6 col-12",
                    name: "clinician_signature_data",
                    id: "clinician_signature_data",
                  },
                  // {
                  //     label:'Status',
                  //     type:'SelectList',
                  //     // options:[],
                  //     options:isSet(props.lookupsOptions['chartResult'],[]),
                  //     name:'status',
                  //     id:'status',
                  // },
              ],
            },
            {
              label: "Review / Completion",
              labelStyle: "fw-semibold",
              fields: [
                {
                  type: "ProviderSignOff",
                  col: "col-12",
                  fields: [
                    { label: "Signature PIN", name: "provider_pin", col: "col-12" },
                    { label: "Signature", type: "NewSignature", name: "provider_signature", col: "col-12" },
                    { label: "Date", type: "Date", name: "signed_date", col: "col-12" },
                    {
                      label: "Final Results",
                      type: "SelectList",
                      name: "status",
                      col: "col-12",
                      options: optionsToKeyValuePairs(
                        [
                          "Not Started",
                          "Pending",
                          "Normal",
                          "Abnormal",
                          "Negative",
                          "Positive",
                          "Dispensed",
                          "Administered",
                          "Failed",
                          "Passed",
                          "Non-Negative",
                          "Cancelled",
                          "Inconclusive",
                        ],
                        false
                      ),
                      statusBasedColor: true,
                    },
                    {
                      label: "Activity Status",
                      type: "SelectList",
                      name: "activity_status",
                      col: "col-12",
                      options: optionsToKeyValuePairs(
                        [
                          "Not Started",
                          "Pending",
                          "Pending Lab Confirmation",
                          "Pending MRO Confirmation",
                          "Ready for Review",
                          "Completed",
                          "Cancelled",
                        ],
                        false
                      ),
                      statusBasedColor: true,
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          id: "Images",
          label: "Images",
          data: []
        },

      ],
    },
  ];
  const headers = [
    {
      type: "Tab",
      data: [
        {
          label: "Patient",
          id: "patient",
        },
        {
          label: "Provider",
          id: "provider",
        },
        {
          label: "Images",
          id: "Images",
        },

      ],
    },
  ];
  const defaultValue = {
    status: "Not Started",
    pulse_rate_result: "Not Started",
    blood_pressure_result: "Not Started",
    vission_result: "Not Started",
    urinalysis_result: "Not Started",
    medical_examiner_determination: "",
  };
  const buttons = {
    PDF: true,
  };
  return {
    charts,
    defaultValue,
    buttons,
    headers,
    computationFunction: (formData, key) => computationRules(formData, key),
  };
};

const computationRules = (formData, key) => {
  const pulse = isSet(formData.pulse_rate, "");
  const systolic = isSet(formData.sitting_systolic, "");
  const diastolic = isSet(formData.sitting_diastolic, "");
  let returnResult = {};

  const currentStatus = isSet(formData.status, "Not Started");
  const currentActivityStatus = isSet(formData.activity_status, "Not Started");

  // If user changes any field while both status and activity_status are "Not Started",
  // move to Pending Result / In Progress
  if (currentStatus === "Not Started" && currentActivityStatus === "Not Started" && key) {
    returnResult.status = "Pending";
    returnResult.activity_status = "Pending";
  }
  if(key === 'status' && formData.status) {
    const status = formData.status;
    // Check if provider has signed (provider_signature exists and is not empty)
    const providerSigned = formData.provider_signature && 
                          formData.provider_signature !== "" && 
                          formData.provider_signature !== null && 
                          formData.provider_signature !== undefined;
    
    switch(status) {
        case 'Not Started':
            returnResult.activity_status = 'Not Started';
            break;
        case 'Pending':
            returnResult.activity_status = 'Pending';
            break;
        case 'Normal':
            // If provider signed, set to Completed; otherwise Pending
            returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
            break;
        case 'Abnormal':
            returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
            break;
        case 'Negative':
            returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
            break;
        case 'Positive':
            returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
            break;
        case 'Dispensed':
            returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
            break;
        case 'Administered':
            returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
            break;
        case 'Failed':
            returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
            break;
        case 'Passed':
            returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
            break;
        case 'Non-Negative':
            returnResult.activity_status = 'Pending Lab Confirmation';
            break;
        case 'Cancelled':
            returnResult.activity_status = 'Cancelled';
            break;
        case 'Inconclusive':
            returnResult.activity_status = 'Pending Lab Confirmation';
            break;
        default:
            // No change if status doesn't match any case
            break;
    }
  }
  
  // Also check when provider_signature changes - if status is a completion status, update activity_status
  if(key === 'provider_signature' && formData.status) {
    const status = formData.status;
    const providerSigned = formData.provider_signature && 
                          formData.provider_signature !== "" && 
                          formData.provider_signature !== null && 
                          formData.provider_signature !== undefined;
    
    // Completion statuses that should become "Completed" when provider signs
    const completionStatuses = ['Normal', 'Abnormal', 'Negative', 'Positive', 'Dispensed', 'Administered', 'Failed', 'Passed'];
    
    if (completionStatuses.includes(status)) {
      returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
    }
  }
  
  let pulseRateResult = "Not Started";
  if (pulse == "") {
    pulseRateResult = "Not Started";
  } else if (pulse >= 60 && pulse <= 100) {
    pulseRateResult = "Normal";
  } else if (pulse !== "") {
    pulseRateResult = "Abnormal";
  }

  let bloodPressureResult = "Not Started";
  if (systolic === "" && diastolic === "") {
    bloodPressureResult = "Not Started";
  } else if (systolic === "" || diastolic === "") {
    bloodPressureResult = "Pending";
  } else if (
    systolic < 0 ||
    systolic > 139 ||
    diastolic < 0 ||
    diastolic > 89
  ) {
    bloodPressureResult = "Abnormal";
  } else {
    bloodPressureResult = "Normal";
  }

  const spgr = isSet(formData.sp_gr, "");
  const protein = isSet(formData.protein, "");
  const blood = isSet(formData.blood, "");
  const sugar = isSet(formData.sugar, "");

  let urinariesResult = "Not Started";

  const sgNormalRange = { min: 1.002, max: 1.03 };
  const sgWithinNormalRange =
    spgr >= sgNormalRange.min && spgr <= sgNormalRange.max;

  // Check Protein, Blood, and Sugar levels
  const abnormalLevels = protein > 0 || blood > 0 || sugar > 0;

  // Determine status
  if (sgNormalRange === "" || protein === "" || blood === "" || sugar === 0) {
    urinariesResult = "Pending";
  } else if (sgWithinNormalRange && !abnormalLevels) {
    urinariesResult = "Normal";
  } else if (!sgWithinNormalRange || abnormalLevels) {
    urinariesResult = "Abnormal";
  } else {
    urinariesResult = "Pending";
  }

  let vissionResult = "Not Started";
  const wearing_corrective_lenses = isSet(
    formData["wearing_corrective_lenses"],
    null
  );
  const conditions =
    wearing_corrective_lenses === 0 ? "uncorrected" : "corrected";
  const horizontalRighteye = isSet(
    formData["horizontal_field_of_vision_right_eye"],
    ""
  );
  const horizontalLeftEye = isSet(
    formData["horizontal_field_of_vision_left_eye"],
    ""
  );
  const applicantRecoginize = isSet(
    formData["applicant_recognize_traffic_control_signals"],
    ""
  );
  const monocularvision = isSet(formData["monocular_vision"], "");

  if (wearing_corrective_lenses !== null) {
    const rightEye = isSet(formData["" + conditions + "_right_eye"], "");
    const bothEyes = isSet(formData["" + conditions + "_both_eyes"], "");
    const leftEye = isSet(formData["" + conditions + "_left_eye"], "");

    if (
      rightEye === "" ||
      bothEyes === "" ||
      leftEye === "" ||
      horizontalRighteye === "" ||
      horizontalLeftEye === ""
    ) {
      vissionResult = "Pending";
    } else if (
      rightEye > 40 ||
      bothEyes > 40 ||
      leftEye > 40 ||
      horizontalRighteye < 70 ||
      horizontalLeftEye < 70
    ) {
      vissionResult = "Failed";
    } else {
      vissionResult = "Passed";
    }
  } else {
    if (horizontalRighteye === "" || horizontalLeftEye === "") {
      vissionResult = "Pending";
    } else if (
      horizontalRighteye < 70 ||
      horizontalLeftEye < 70 ||
      applicantRecoginize === "No" ||
      monocularvision === "No"
    ) {
      vissionResult = "Failed";
    } else {
      vissionResult = "Passed";
    }
  }

  const earPrefixes = ["right_ear_", "left_ear_"];
  earPrefixes.forEach((earPrefix) => {
    const frequencies = [500, 1000, 2000, 3000, 4000, 6000, 8000];
    let total = 0;

    frequencies.forEach((frequency) => {
      const value = isSet(
        formData[`audiometric_test_results_${earPrefix}${frequency}_hz`],
        ""
      );
      total += Number(value);
    });
    const average = Math.ceil(total / frequencies.length);
    returnResult[`audiometric_test_results_${earPrefix}average`] = average;
  });

  const leftAverage =
    returnResult[`audiometric_test_results_right_ear_average`];
  const rightAverage =
    returnResult[`audiometric_test_results_left_ear_average`];
  const whisperTestRightEar = isSet(
    formData[`whisper_test_results_right_ear`],
    ""
  );
  const whisperTestLeftEar = isSet(
    formData[`whisper_test_results_left_ear`],
    ""
  );
  let hearingResult = "Not Started";
  if (
    Number(leftAverage) === 0 &&
    Number(rightAverage) === 0 &&
    whisperTestRightEar == "" &&
    whisperTestLeftEar === ""
  ) {
    hearingResult = "Not Started";
  } else if (
    (leftAverage !== "0.00" && leftAverage <= 40 && leftAverage !== 0) ||
    (rightAverage !== "0.00" && rightAverage <= 40 && rightAverage !== 0) ||
    whisperTestRightEar >= 5 ||
    whisperTestLeftEar >= 5
  ) {
    // console.log('ssss',leftAverage,rightAverage,whisperTestRightEar,whisperTestLeftEar);
    hearingResult = "Passed";
  } else if (
    (leftAverage === 0 || rightAverage === 0) &&
    (leftAverage > 40 || rightAverage > 40)
  ) {
    hearingResult = "Failed";
  } else if (
    leftAverage > 40 ||
    rightAverage > 40 ||
    (whisperTestRightEar < 5 && whisperTestLeftEar < 5)
  ) {
    hearingResult = "Failed";
  } else {
    hearingResult = "Pending";
  }
  returnResult = {
    ...returnResult,
    pulse_rate_result: pulseRateResult,
    blood_pressure_result: bloodPressureResult,
    vission_result: vissionResult,
    hearing_result: hearingResult,
    urinalysis_result: urinariesResult,
    certification_suggested_length: getCertificationLength(systolic, diastolic),
  };
  return returnResult;
};

// export const fetchProviderList = async (val, props, callback = () => {}) => {
//   const { employeeDetails } = props;
//   let optionArr = [];
//   try {
//     const data = await ProviderService.getProviderByClinicId(
//       employeeDetails.clinic_id,
//       { search: val }
//     );
//     isSet(data, []).map((item, itemIndex) => {
//       optionArr.push({
//         label: isSet(item.first_name, "") + " " + isSet(item.last_name, ""),
//         value: item.provider_id,
//         autoPopulateFields: {
//           medical_examiners_license_certificate_or_registration_number:
//             item.license,
//           national_registry_number: item.dol_registry_id,
//           medical_examiners_certificate_expiration_date:
//             item.dol_registry_expires,
//         },
//         data: item,
//         index: itemIndex,
//       });
//     });
//     callback(optionArr);
//   } catch (e) {}
//   return optionArr;
// };

export const getCertificationLength = (systolic, diastolic) => {
  if (systolic === "" || diastolic === "") {
    return "";
  }
  if (systolic < 140 && diastolic < 90) {
    return "2 year DOT Certificate";
  } else if (
    systolic >= 140 &&
    systolic <= 159 &&
    diastolic >= 90 &&
    diastolic <= 99
  ) {
    return "1 year DOT Certificate";
  } else if (
    systolic >= 160 &&
    systolic <= 179 &&
    diastolic >= 100 &&
    diastolic <= 109
  ) {
    return "3 month DOT Certificate";
  } else if (systolic >= 180 || diastolic >= 110) {
    return "Disqualified";
  } else {
    return "1 year DOT Certificate";
  }
};
